import type { FC } from "react";

import {
  BROWSER_NO_VALIDATION_MAP,
  FORM_DEFAULTS,
  type TFormProps,
} from "@/ui/components/form/Form/Form.config";

export const Form: FC<TFormProps> = (
  {
    children,
    "data-component": component = "Form",
    validation = FORM_DEFAULTS.validation,
    ...props
  },
) => (
  <form
    {...props}
    noValidate={BROWSER_NO_VALIDATION_MAP[validation]}
    data-component={component}
  >
    { children }
  </form>
);

Form.displayName = "Form";
